import React, { ReactElement, useState } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import SeatRequestModal from '../../../../SeatRequestModal';

export const COPY = defineMessages({
  SEAT_REQUEST: {
    id: 'ButtonSeatUpgrade.SeatRequest',
    defaultMessage: 'Request power seat',
    description:
      '[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade.',
  },
});

const ButtonUpgradeSeat = (): ReactElement => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        color="alt"
        size="sm"
        disabled={showModal}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <T desc={COPY.SEAT_REQUEST} />
      </Button>
      <SeatRequestModal
        show={showModal}
        onClose={() => setShowModal(false)}
        sourceCategoryKey="global_header"
      />
    </>
  );
};

export default ButtonUpgradeSeat;
